<template>
  <router-view />
</template>

<style>
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

h1, h2 {
  font-family: 'Pricedown', sans-serif;
  letter-spacing: 1px;
  text-align: center;
}

.my-container {
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

@font-face {
  font-family: 'Pricedown';
  src: url('./assets/fonts/Pricedown.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

</style>
